module.exports = __webpack_public_path__ + "static/chart-6c23c168248ad047a6c0b1383e2fcd6e.png";